module.exports = __webpack_public_path__ + "img/AngelaRoark.733873c4.jpg";